import { Injectable, inject } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { HoldsState,  } from './holds.state';
import { Hold } from './models/hold';
import { GetHolds, PostHold, SetHold, RemoveHold } from './holds.actions';

@Injectable({
  providedIn: 'root',
})
export class HoldsFacade {
  private readonly store = inject(Store);

  @Select(HoldsState.getHolds) holds$!: Observable<Hold[]|null>;
  @Select(HoldsState.getIsLoading) isLoading$!: Observable<boolean>;

  get holds() {
    return this.store.selectSnapshot(HoldsState.getHolds);
  }

  getHolds(): Observable<GetHolds> {
    return this.store.dispatch(new GetHolds());
  }

  postHold(recordId, from, issueDate?, rhId?): Observable<PostHold> {
    return this.store.dispatch(new PostHold(recordId, from, issueDate, rhId));
  }

  setHold(hold: Hold): Observable<SetHold> {
    return this.store.dispatch(new SetHold(hold));
  }

  deleteHold(holdId: string): Observable<RemoveHold> {
    return this.store.dispatch(new RemoveHold(holdId));
  }

  getHoldByRecordId(recordId: string, issueDate?: string, rhId?: string, physicalRecord?: string): Hold {
    if (this.holds === null) {
      return undefined;
    }

    if (issueDate) {
      return this.holds.filter((h) => h.parentRecordId === recordId).find((h) => h.issueDate === issueDate);
    }

    if (rhId) {
      return this.holds.filter((h) => h.parentRecordId === recordId).find((h) => h.rssRhId === rhId);
    }

    if (physicalRecord) {
      return this.holds.find((h) => h.recordId === physicalRecord);
    }

    return this.holds.find((hold) => hold.parentRecordId === recordId);
  }
}
